import { TableProps } from 'antd';
import Table from 'components/Table';
import { RizeUser, TablePagination } from 'types/common';
import { UsersResponse } from 'types/response';
import renderUsersTableHeader from './UsersTableHeader';

type UsersTableProps = {
  country: string;
  data: UsersResponse;
  isLoading: boolean;
  pagination: TablePagination;
  selectedRow?: RizeUser;
  onTableChange: TableProps<RizeUser>['onChange'];
  handleAction: (data: RizeUser, type: 'detail' | 'assign') => void;
};

export type UserTableData = Omit<RizeUser, 'reportingTo'> & {
  reportingToUserEmailList?: string[];
};

export default function UsersTable({
  data,
  isLoading,
  pagination,
  selectedRow,
  onTableChange,
  handleAction,
}: UsersTableProps) {
  const { total, currentPage, pageSize, handlePageChange } = pagination;

  const formatTableData = (data: UsersResponse): UserTableData[] => {
    return data?.map((user) => ({
      ...user,
      reportingToUserEmailList: user?.reportingTo?.map(
        (each) => each.reportingManagerEmail,
      ),
    }));
  };

  return (
    <Table
      tableColumns={formatTableData(data)}
      tableHeader={renderUsersTableHeader(handleAction)}
      loading={isLoading}
      highlightColor="gray"
      highlighted={selectedRow?.id}
      pagination={{
        total: total,
        current: currentPage,
        pageSize: pageSize,
        onChange: handlePageChange,
        onShowSizeChange: handlePageChange,
      }}
      onChange={onTableChange}
    />
  );
}
